export default __webpack_public_path__ + "static/memphis-07ecd01b3b3b44a54060c49c35b7f64b.png";